import AdminApp from './AdminApp'

// dugeun.heart-way.life 서브도메인 전체가 어드민 전용이므로 /dugeun prefix 없이 mount.
// AdminApp 내부에서 React Router로 nested routing 처리.
export default function App() {
  return <AdminApp />
}
